import React from 'react';
import PropTypes from 'prop-types';
import InputGroupWrapper from '../../InputGroupWrapper';
import messages from '../registrationMessages';
import FormGroupPart from './FormGroupPart';
import NumberInput from '../../input/NumberInput';

const CostQuantityPart = ({ quantity, onChange, disabled, showValidation }) => (
  <FormGroupPart label={messages.Quantity} invalid={showValidation && !quantity}>
    <InputGroupWrapper className="input-group-sm">
      <NumberInput
        id="quantityField"
        min={0}
        disabled={disabled}
        value={quantity}
        onChange={onChange}
        className="form-control input-sm"
      />
    </InputGroupWrapper>
  </FormGroupPart>
);
CostQuantityPart.propTypes = {
  quantity: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  showValidation: PropTypes.bool,
};
CostQuantityPart.defaultProps = {
  quantity: 0,
  disabled: false,
  showValidation: false,
};
export default CostQuantityPart;
